import { Injectable } from '@angular/core';
import { InventariosService } from './inventarios.service';
import { UtilitiesService } from './Utility/utilities.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { first } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ExportacionSeriesService {

  creatingFile = false;

  constructor(private inventariosService: InventariosService,
    private utilitiesService: UtilitiesService,
    private toastr: ToastrService,
    private translateService: TranslateService) { }

  exportSerieDocumental(serie: number) {
    this.creatingFile = true;
    this.inventariosService.getExportFileByDocumentalSerie(serie)
      .pipe(first()).subscribe(result => {
        this.creatingFile = false;

        if (result.type == 'text/plain') {
          this.toastr.info(this.translateService.instant('generales.manyRecords'));
          return;
        }
        this.utilitiesService.downloadGenericFile('ExportacionSerieDocumental' + serie + '.xlsx', result);
        this.toastr.info(this.translateService.instant('generales.exportFileSerieSuccess'));
      }, error => {
        this.creatingFile = false;
      });
  }
}
